import i18n from '@/i18n';

/**
 * Returns the BCP 47 locale tag to use with Intl APIs.
 * 'es' maps to 'es-419' (Latin American Spanish) so that number, currency,
 * and date formatting follows LATAM conventions rather than European ones.
 * Update this mapping if Spain (es-ES) support is added.
 */
function getFormattingLocale(): string {
  const lang = i18n.language || 'en';
  return lang === 'es' ? 'es-419' : lang;
}

export default getFormattingLocale;
